import React, { useState } from "react";
import {
  ButtonBack,
  Circle,
  Container,
  SubTitle,
  Title,
  ViewInput,
  ViewMax,
} from "./styles";
import playstore from "./../images/playstore.png";
import appstore from "./../images/appstore.png";
import user from "./../images/user.png";
import arrow from "./../images/arrow.png";
import logo from "./../images/logo.png";
import star from "./../images/star.png";
import { Button, Input } from "antd";
import { MdAddPhotoAlternate, MdChevronLeft } from "react-icons/md";
import ReactInputMask from "react-input-mask";
import { useQuery } from "../hooks/Location";
import api from "../services/api";
import { toast } from "react-toastify";
import { Download, Loja, Message, Photo } from "../Error/styles";
import { useNavigate } from "react-router-dom";

export default function Register() {
  const navigate = useNavigate();
  const query = useQuery();

  const qrcode = query.get("qrcode");
  const partner = query.get("partner");

  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number, setPhone_number] = useState("");
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorNickname, setErrorNickname] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(true);
  const [passwordConfirmVisible, setPasswordConfirmVisible] = useState(true);
  const [nickname, setNickname] = useState("");
  const [description, setDescription] = useState("");
  const [instagram, setInstagram] = useState("");
  const [photo, setPhoto] = useState("");
  const [code, setCode] = useState("");
  const [etapa, setEtapa] = useState(qrcode ? 1 : 0);

  async function createUser() {
    setLoading(true);
    const data = new FormData();

    data.append("name", name);
    data.append("description", description);
    data.append("email", email.toLowerCase());
    data.append("phone_number", phone_number);
    data.append("password", password);
    data.append("nickname", nickname.replace(/ /g, "").toLowerCase());
    data.append("code", code);
    data.append("qrcode", qrcode || "");
    data.append("partner_id", partner || "");
    data.append("instagram", instagram);

    if (photo.name) {
      data.append("file", photo, photo.name);
    }

    await api
      .post("/user-web", data)
      .then(() => {
        toast.success("Cadastro realizado com sucesso");
        setConfirm(true);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          if (response?.data?.message == "Usuário já está em uso") {
            setErrorNickname(true);
            setEtapa(6);
          }
          if (
            response?.data?.message == "Email já cadastrado" ||
            response?.data?.message == "Email é inválido"
          ) {
            setErrorEmail(true);
            setEtapa(1);
          }
          toast.error(response?.data?.message);
        } else {
          toast.error("Ocorreu um erro ao realizar o cadastro");
        }
      });
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }

  async function verifyNickname() {
    setLoading(true);
    await api
      .get(`/verify-nickname/${nickname.toLowerCase()}`)
      .then((response) => {
        setEtapa(etapa + 1);
      })
      .catch(({ response }) => {
        setErrorNickname(true);
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.error(response.data.message);
            } else {
              toast.error("Ocorreu um erro interno");
            }
          } else {
            toast.error("Ocorreu um erro interno");
          }
        } else {
          toast.error("Ocorreu um erro interno");
        }
      });
    setLoading(false);
  }

  async function verifyEmail() {
    setLoading(true);
    await api
      .get(`/verify-email/${email.toLowerCase()}`)
      .then((response) => {
        setEtapa(etapa + 1);
      })
      .catch(({ response }) => {
        setErrorEmail(true);
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.error(response.data.message);
            } else {
              toast.error("Ocorreu um erro interno");
            }
          } else {
            toast.error("Ocorreu um erro interno");
          }
        } else {
          toast.error("Ocorreu um erro interno");
        }
      });
    setLoading(false);
  }

  return (
    <Container>
      {confirm ? (
        <ViewMax style={{ justifyContent: "center" }}>
          <Message
            style={{
              marginTop: 0,
            }}
          >
            Cadastro concluído com sucesso!
          </Message>
          <Circle>1</Circle>
          <Message style={{ fontSize: 12, marginTop: 0, maxWidth: 300 }}>
            Baixe o aplicativo e tenha o melhor da tecnologia na palma da sua
            mão.
          </Message>
          <Download style={{ marginTop: 0, marginBottom: 20 }}>
            <Loja
              onClick={() => {
                window.open(
                  "https://apps.apple.com/br/app/qr-bio/id6444109866",
                  "_blank",
                );
              }}
              src={appstore}
            />
            <Loja
              onClick={() => {
                window.open(
                  "https://play.google.com/store/apps/details?id=solucoesdaweb.qrbio",
                  "_blank",
                );
              }}
              src={playstore}
            />
          </Download>
          <img src={arrow} />
          <Circle style={{ marginTop: 15, marginBottom: 5 }}>2</Circle>
          <Button
            type="primary"
            style={{
              margin: "20px 0",
              width: "80%",
              height: 40,
              fontSize: 18,
              maxWidth: 300,
              borderRadius: 10,
              color: "#363636",
              fontFamily: "Montserrat-Medium",
            }}
            onClick={() => {
              navigate(`/${nickname}`);
            }}
          >
            Visualizar Perfil
          </Button>
          <div
            onClick={() => {
              window.open("https://qrbio.com.br/", "_blank");
            }}
            style={{
              cursor: "pointer",
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              width: 150,
            }}
          >
            <img src={logo} style={{ height: 20 }} />
            <Message
              style={{
                fontSize: 12,
                marginTop: 5,
                marginBottom: 5,
                maxWidth: 300,
              }}
            >
              qrbio.com.br
            </Message>
          </div>
        </ViewMax>
      ) : (
        <ViewMax>
          {etapa > 1 && (
            <ButtonBack
              disabled={loading}
              onClick={() => {
                setEtapa(etapa - 1);
              }}
            >
              <MdChevronLeft color="#363636" size={30} />
            </ButtonBack>
          )}
          {etapa == 0 && (
            <>
              <>
                <Photo src={star} style={{ marginTop: 80 }} />
                <Message>Seja bem-vindo</Message>

                <Message style={{ fontSize: 12, marginTop: 0, maxWidth: 300 }}>
                  Estamos felizes em ter você conosco!
                </Message>
                <Message style={{ fontSize: 12, marginTop: 0, maxWidth: 300 }}>
                  Vamos iniciar seu cadastro, preencha todas informações para
                  seu perfil ficar completo.
                </Message>
                <Button
                  type="primary"
                  style={{
                    margin: "10px 0",
                    width: "70%",
                    height: 40,
                    fontSize: 16,
                    maxWidth: 240,
                    borderRadius: 8,
                    color: "#363636",
                    fontFamily: "Montserrat-Medium",
                  }}
                  onClick={() => {
                    setEtapa(1);
                  }}
                >
                  Criar nova conta
                </Button>
              </>
            </>
          )}
          {etapa == 1 && (
            <>
              <Title>Adicione o seu e-mail</Title>
              <SubTitle>
                Você usará esse email quando fizer login e sempre que precisar
                redefinir sua senha.
              </SubTitle>
              <ViewInput>
                <p>EMAIL</p>
                <Input
                  value={email}
                  status={errorEmail && "error"}
                  placeholder="digite seu email"
                  inputMode="email"
                  autoCapitalize="off"
                  style={{
                    height: 40,
                    fontFamily: "Montserrat-Medium",
                  }}
                  onChange={(e) => {
                    setEmail(e.target.value.replace(/ /g, "").toLowerCase());
                    setErrorEmail(false);
                  }}
                />
              </ViewInput>
            </>
          )}
          {etapa == 2 && (
            <>
              <Title>Qual o seu nome?</Title>
              <SubTitle></SubTitle>
              <ViewInput>
                <p>NOME</p>
                <Input
                  value={name}
                  placeholder="digite seu nome"
                  style={{
                    height: 40,
                    fontFamily: "Montserrat-Medium",
                  }}
                  onChange={(e) => setName(e.target.value)}
                />
              </ViewInput>
            </>
          )}
          {etapa == 3 && (
            <div
              style={{
                marginTop: 0,
                width: 220,
                height: 160,
                borderRadius: 10,
                marginBottom: 12,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
              }}
            >
              <img
                style={{
                  width: 160,
                  height: 160,
                  borderRadius: 160,
                }}
                src={photo.photo_url ? photo.photo_url : user}
              />
              <label
                for="avatar"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  top: -10,
                  right: 0,
                  position: "absolute",
                  background: "transparent",
                }}
              >
                <MdAddPhotoAlternate color="#FFF" size={35} />
                <input
                  id="avatar"
                  style={{ display: "none" }}
                  type="file"
                  accept="image/png, image/jpeg"
                  onChange={(file) => {
                    let photo = file.target.files[0];
                    photo.photo_url = URL.createObjectURL(file.target.files[0]);
                    setPhoto(photo);
                  }}
                />
              </label>
            </div>
          )}
          {etapa == 4 && (
            <>
              <Title>Informe o número do seu celular?</Title>
              <SubTitle>
                Confirme que o código de área está incluido no seu numero de
                celular, esse número será no seu perfil
              </SubTitle>
              <ViewInput>
                <p>NÚMERO DE CELULAR</p>
                <ReactInputMask
                  mask="99 99999-9999"
                  value={phone_number}
                  onChange={(e) => setPhone_number(e.target.value.slice(0, 13))}
                  maskChar={null}
                >
                  {(inputProps) => (
                    <Input
                      placeholder="digite seu telefone"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      style={{
                        height: 40,
                        fontFamily: "Montserrat-Medium",
                      }}
                    />
                  )}
                </ReactInputMask>
              </ViewInput>
            </>
          )}
          {etapa == 5 && (
            <>
              <Title>Escolha sua senha</Title>
              <SubTitle>
                Crie uma senha com pelo menos 6 carecteres. Ela deve ser algo
                que outras pessoas não consigam adivinhar.
              </SubTitle>
              <ViewInput>
                <p>SENHA</p>
                <Input.Password
                  value={password}
                  placeholder="digite sua senha"
                  style={{
                    height: 40,
                    fontFamily: "Montserrat-Medium",
                  }}
                  autoCapitalize="off"
                  visibilityToggle={{
                    visible: passwordVisible,
                    onVisibleChange: setPasswordVisible,
                  }}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </ViewInput>
              <ViewInput style={{ marginTop: 10 }}>
                <p>CONFIRMAR SENHA</p>
                <Input.Password
                  value={passwordConfirm}
                  placeholder="confirme sua senha"
                  autoCapitalize="off"
                  style={{
                    height: 40,
                    fontFamily: "Montserrat-Medium",
                  }}
                  visibilityToggle={{
                    visible: passwordConfirmVisible,
                    onVisibleChange: setPasswordConfirmVisible,
                  }}
                  onChange={(e) => setPasswordConfirm(e.target.value)}
                />
              </ViewInput>
            </>
          )}

          {etapa == 6 && (
            <>
              <Title>Usuário de Perfil</Title>
              <SubTitle style={{ marginBottom: 10 }}>
                Esse será o nome usado na URL do seu perfil. Por exemplo: se
                você escolher rodrigo, sua URL será: https://qrbio.me/rodrigo
              </SubTitle>
              <SubTitle style={{ marginTop: 0 }}>
                Escolha um nome fácil de lembrar e que identifique você ou seu
                negócio.
              </SubTitle>
              <ViewInput>
                <p>USUÁRIO</p>
                <Input
                  value={nickname}
                  addonBefore="qrbio.me/"
                  placeholder="digite seu usuário"
                  autoCapitalize="off"
                  status={errorNickname && "error"}
                  styles={{
                    addonBefore: {
                      backgroundColor: "#fffFFF",
                      padding: "5px 10px",
                      borderRadius: "6px 0 0 6px",
                    },
                  }}
                  style={{
                    height: 40,
                    fontFamily: "Montserrat-Medium",
                  }}
                  onChange={(e) => {
                    setNickname(e.target.value.replace(/ /g, "").toLowerCase());
                    setErrorNickname(false);
                  }}
                />
              </ViewInput>
            </>
          )}
          {etapa == 7 && (
            <>
              <Title>Biografia do Perfil</Title>
              <SubTitle>
                Faça uma descrição sobre voce ou use pra colocar um cargo,
                profissão ou slogan
              </SubTitle>
              <ViewInput>
                <p>BIOGRAFIA DO PERFIL</p>
                <Input.TextArea
                  value={description}
                  placeholder="biografia do Perfil "
                  style={{
                    minHeight: 150,
                    fontFamily: "Montserrat-Medium",
                  }}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </ViewInput>
            </>
          )}
          {etapa == 8 && (
            <>
              <Title>Adicione o instagram</Title>
              <SubTitle></SubTitle>
              <ViewInput>
                <p>INSTAGRAM</p>
                <Input
                  value={instagram}
                  addonBefore="@"
                  placeholder="digite seu usuario do instagram"
                  autoCapitalize="off"
                  styles={{
                    addonBefore: {
                      backgroundColor: "#000000 !important",
                      color: "#000000",
                      padding: "5px 10px",
                      borderRadius: "6px 0 0 6px",
                    },
                  }}
                  style={{
                    height: 40,
                    fontFamily: "Montserrat-Medium",
                  }}
                  onChange={(e) =>
                    setInstagram(e.target.value.replace(/ /g, "").toLowerCase())
                  }
                />
              </ViewInput>
            </>
          )}

          {etapa == 9 && (
            <>
              <Title>Resgatar Cupom Promocional</Title>
              <SubTitle>Você tem um Cupom Promocional para resgatar?</SubTitle>
              <Button
                loading={loading}
                type="primary"
                style={{
                  marginTop: 0,
                  marginBottom: -10,
                  width: "90%",
                  fontSize: 16,
                  height: 40,
                  color: "#363636",
                  fontFamily: "Montserrat-Medium",
                }}
                onClick={() => {
                  createUser();
                }}
              >
                Não, Concluir Cadastro
              </Button>
            </>
          )}
          {etapa == 10 && (
            <>
              <Title>Resgatar Cupom Promocional</Title>
              <SubTitle>
                Insira o seu Cupom Promocional, caso não tenha. Pode avançar.
              </SubTitle>
              <ViewInput>
                <p>CUPOM DE RESGATE</p>
                <Input
                  value={code}
                  placeholder="digite o cupom de resgate"
                  style={{
                    height: 40,
                    fontFamily: "Montserrat-Medium",
                  }}
                  allowClear
                  onChange={(e) =>
                    setCode(e.target.value.replace(/ /g, "").toUpperCase())
                  }
                />
              </ViewInput>
            </>
          )}

          {etapa > 0 && (
            <Button
              disabled={loading && etapa == 9}
              loading={loading && etapa != 9}
              type="primary"
              style={{
                marginTop: 30,
                width: "90%",
                fontSize: 16,
                height: 40,
                color: "#363636",
                background: "#20D072",
                border: "none",
                fontFamily: "Montserrat-Medium",
              }}
              onClick={() => {
                switch (etapa) {
                  case 1: {
                    if (!email) {
                      toast.warn("Preencha o email do perfil");
                    } else {
                      verifyEmail();
                    }
                    break;
                  }
                  case 2: {
                    if (!name) {
                      toast.warn("Preencha o nome do perfil");
                    } else {
                      setEtapa(etapa + 1);
                    }
                    break;
                  }
                  case 3: {
                    if (!photo) {
                      toast.warn("Envie sua foto do perfil");
                    } else {
                      setEtapa(etapa + 1);
                    }
                    break;
                  }
                  case 4: {
                    if (!phone_number) {
                      toast.warn("Preencha o telefone do perfil");
                    } else {
                      if (phone_number.length != 13) {
                        toast.warn("Preencha um telefone válido");
                      } else {
                        setEtapa(etapa + 1);
                      }
                    }
                    break;
                  }
                  case 5: {
                    if (!password || !passwordConfirm) {
                      toast.warn("Preencha a senha e confirmação de senha");
                    } else {
                      if (password != passwordConfirm) {
                        toast.warn("Senhas não correspondem");
                      } else {
                        setEtapa(etapa + 1);
                      }
                    }
                    break;
                  }
                  case 6: {
                    if (!nickname) {
                      toast.warn("Preencha o usuário do perfil");
                    } else {
                      verifyNickname();
                    }
                    break;
                  }
                  case 7: {
                    setEtapa(etapa + 1);
                    break;
                  }
                  case 8: {
                    setEtapa(etapa + 1);
                    break;
                  }
                  case 9: {
                    setEtapa(etapa + 1);
                    break;
                  }
                  case 10: {
                    createUser();
                  }
                }
              }}
            >
              {etapa == 10
                ? "Concluir Cadastro"
                : etapa == 9
                  ? "Sim, Preencher Cupom"
                  : "Avançar"}
            </Button>
          )}
          {etapa == 3 && (
            <p
              onClick={() => {
                setEtapa(4);
              }}
              style={{
                marginTop: 25,
                fontSize: 15,
                fontFamily: "Montserrat-Medium",
                color: "#FFF",
                cursor: "pointer",
              }}
            >
              Enviar imagem depois
            </p>
          )}
        </ViewMax>
      )}
    </Container>
  );
}
